import React, { Component } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import { loadNextRace, isNextRaceLoading } from 'modules/HorseRacing/reducers/nextrace';
import { slug } from 'utils';
import { sortByOdds } from 'utils/compare';
import { filterRidesByStatus } from 'modules/HorseRacing/utils/rideFilter';
import {localTimeShort} from 'utils/LocalDateTimeHelper';

import CaretLink from 'modules/Common/components/CaretLink';
import HorseRacingRideSummaryTable from 'modules/HorseRacing/components/HorseRacingRideSummaryTable'

@layoutAsyncConnect(
  "HorseRacingNextRaceOff",
  [{
    dispatch: () => loadNextRace(),
    preventResolve: ({state}) => isNextRaceLoading(state),
    refreshInterval: 30000,
    state: state => ({ race: state.horseRacing.nextrace }),
    handleError: true
  }]
)
export default class HorseRacingNextRaceOff extends Component {

  static propTypes = {
    plainTitle: PropTypes.bool,
    race: PropTypes.shape({
      race: PropTypes.object
    }).isRequired,
    displayAll: PropTypes.bool,
    dispatch: PropTypes.func.isRequired
  }

  generateRacecardLink(race) {

    const raceSummary = race.race_summary || {};

    const date = raceSummary.date;
    const courseName = raceSummary.course_name && slug(raceSummary.course_name).toLowerCase();
    const raceName = raceSummary.name && slug(raceSummary.name).toLowerCase();

    const raceRef = raceSummary.race_summary_reference || {};
    const raceId = raceRef.id;

    if (date == null || courseName == null || raceId == null) {
      return null
    } else {
      return (
        <Link className="section-button large-primary-blue-button" to={`/racing/racecards/${date}/${courseName}/racecard/${raceId}/${raceName}`}>
          Full Racecard
        </Link>
      )
    }
  }

  render() {
    require('./HorseRacingNextRaceOff.scss');

    const race = this.props.race.race || {};
    const raceSummary = race.race_summary || {};

    const raceTitleParts = [];

    if (raceSummary.time && raceSummary.date) {
      raceTitleParts.push(localTimeShort(`${raceSummary.date}T${raceSummary.time}Z`));
    }

    if (raceSummary.course_name) {
      raceTitleParts.push(raceSummary.course_name);
    }

    const raceTitle = raceTitleParts.join(" ");
    const raceSummaryRef = raceSummary.race_summary_reference || {};
    const raceExternalIds = raceSummaryRef.external_reference || [];
    const raceSkyBetIds = raceExternalIds.filter(r => r.ref === 'skybet').map(r => r.value);
    const raceExternalId = raceSkyBetIds.length > 0 ? raceSkyBetIds[0] : '';
    const rides = race.rides || [];
    const runners = filterRidesByStatus(rides, "RUNNER").sort(sortByOdds);

    let runnersToDisplay = runners;
    if (this.props.displayAll !== true) {
      runnersToDisplay = runners.slice(0, race.number_of_placed_rides);
    }

    let titleClass = "section-title";
    if (this.props.plainTitle === true) {
      titleClass = `${titleClass} ${titleClass}-plain`;
    }
    else {
      titleClass = `${titleClass} ${titleClass}-full`;
    }

    const errorPixelSrc = `/1x1.gif?type=next-race-off&id=0&cb=${Date.now()}`;

    return (
      <div className="sport-section next-race-off" id="next-race-off">
        <h3 className={titleClass}>Next Race Off</h3>
        { raceTitle
          ?
            <div>
              <div className="section-subtitle">{raceTitle}</div>
              <HorseRacingRideSummaryTable runners={runnersToDisplay} raceExternalId={raceExternalId} raceSummary={race.race_summary} eachWay={race.each_way}
                  suspended={race.market_suspended} fixture={race.fixture}/>
            </div>
          :
            <div>
                <div className="next-race-off-error">Unable to display the next race off.</div>
                <img src={errorPixelSrc} width="1" height="1" />
            </div>
        }
        <div className="action-links">
          {this.generateRacecardLink(race)}
          <Link className="section-button large-primary-button" to="/racing/racecards">All Racecards</Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Common/containers/HorseRacingNextRaceOff.js